import React, { createContext, useContext, useEffect, useState } from "react"
import {UserSettings, UserSettingsState} from "./types"
import { useCommonEventBus } from "../hooks/useCommonEventBus"
import { InitFromCache } from "./effects/InitFromCache"

interface ContextType {
  isReady: boolean;
  state: UserSettingsState;
  api: {
    setLoading: (loading: boolean) => void;
    setData: (data: UserSettings) => void;
  }
}

const UserSettingsContext = createContext({ isReady: false } as ContextType)

// UserSettingsContext.displayName = "UserSettingsContext"

class IProps {
  location: "root" | "portal" = "portal"
  fetchEffect: any
  children: any
}

function UserSettingsProvider(props: IProps) {

  const { fetchEffect, children } = props

  const bus = useCommonEventBus()
  const [state, setState] = useState(new UserSettingsState())

  useEffect(() => {
    if (props.location === "root") {
      bus.emit("App > UserSettings > Fetch")
    } else {
      bus.emit("App > UserSettings > InitFromCache")
    }
  }, [])

  const context: ContextType = {
    isReady: true,
    state,
    api: {
      setLoading: (loading) => setState(prev => {
        return { ...prev, loading }
      }),
      setData: (data) => setState(prev => {
        return { ...prev, ...data, areLoaded: true }
      })
    }
  }

  // if (!state.globalSettingsLoaded) return (<div>Loading global settings...</div>)

  return (
    <UserSettingsContext.Provider value={context}>
  
      {fetchEffect}
      
      <InitFromCache />
  
      {children}

    </UserSettingsContext.Provider>
  )
}

function useUserSettings() {
  return useContext(UserSettingsContext) as ContextType
}

export { UserSettingsProvider, useUserSettings }
